import Switch from 'components/shared/Switch/Switch';

const DataMapOptions = ({ show, setShow }) => {
  return (
    <ul className="flex max-w-[320px] flex-col gap-2 text-primary-900">
      <li className="flex items-center justify-between gap-10">
        <p>Generate emails when empty</p>
        <Switch
          checked={show.generateEmails}
          onChange={() =>
            setShow({
              ...show,
              generateEmails: !show.generateEmails
            })
          }
        />
      </li>
      <li className="flex items-center justify-between gap-10">
        <p>Select a Default Service for Appointments</p>
        <Switch
          checked={show.defaultService}
          onChange={() =>
            setShow({
              ...show,
              defaultService: !show.defaultService
            })
          }
        />
      </li>
      <li className="flex items-center justify-between gap-10">
        <p>Select a Default Provider for Appointments</p>
        <Switch
          checked={show.defaultProvider}
          onChange={() =>
            setShow({
              ...show,
              defaultProvider: !show.defaultProvider
            })
          }
        />
      </li>
    </ul>
  );
};

export default DataMapOptions;
